define.alias("shared/components/shared/wizard/next-button", "settings/components/shared/wizard/next-button");